/* eslint-disable no-underscore-dangle */
import React from 'react';
import moment from 'moment';
import Link from 'next/link';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { getObjectByLanguage } from 'language/helpers';

const BlogListItem = (props) => {
  const { blog } = props;

  return (
    <Link href={`/blog/${blog.id}`}>
      <a className="blog-card">
        <div className="blog-card-image">
          <Image
            src={blog.image}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className="blog-card-text-area">
          <span className="blog-card-date">
            <strong>
              {moment(blog.date).format('DD MMMM YYYY, HH:mm')}
            </strong>
            {' '}
            tarihinde yayınlandı.
          </span>
          <span className="blog-card-title">{getObjectByLanguage(blog.title)}</span>
          <span className="blog-card-description">{blog.description}</span>
        </div>
      </a>
    </Link>
  );
};

BlogListItem.propTypes = {
  blog: PropTypes.object.isRequired,
};

export default BlogListItem;
